import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackMetaAccountConfigurationSaved.meta';

export const useTrackMetaAccountConfigurationSaved = () => {
  const { track } = useAnalyticsUtilities();

  const trackMetaAccountConfigurationSaved = useCallback(() => {
    track(META.name);
  }, [track]);

  return { trackMetaAccountConfigurationSaved };
};
